// src/pages/ResetPassword.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // checking | ready | error | success
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const oobCode = searchParams.get('oobCode') || searchParams.get('oobcode');

  useEffect(() => {
    if (!oobCode) {
      setError('Código de restablecimiento ausente en la URL.');
      setStatus('error');
      return;
    }

    // Verify the code and get the email associated
    setStatus('checking');
    verifyPasswordResetCode(auth, oobCode)
      .then((emailFromCode) => {
        setEmail(emailFromCode);
        setStatus('ready');
      })
      .catch((err) => {
        console.error('verifyPasswordResetCode error', err);
        setError('Código inválido o expirado.');
        setStatus('error');
      });
  }, [oobCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!password || password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    setStatus('checking');
    try {
      await confirmPasswordReset(auth, oobCode, password);
      setStatus('success');
      // Redirect to login after short delay
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      console.error('confirmPasswordReset error', err);
      setError('No se pudo restablecer la contraseña. El código puede ser inválido o expirado.');
      setStatus('error');
    }
  };

  return (
    <div style={{ maxWidth: 680, margin: '60px auto', padding: 24, background: '#fff', borderRadius: 8 }}>
      <h2>Restablecer contraseña</h2>
      {status === 'checking' && <p>Verificando enlace...</p>}
      {status === 'error' && (
        <div>
          <p style={{ color: 'crimson' }}>{error || 'Error verificando el enlace.'}</p>
          <p>Si el enlace expiró solicita uno nuevo desde el login.</p>
        </div>
      )}

      {status === 'ready' && (
        <div>
          <p>Restablecer contraseña para: <strong>{email}</strong></p>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 6 }}>Nueva contraseña</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '100%', padding: 8 }} />
            </div>
            {error && <p style={{ color: 'crimson' }}>{error}</p>}
            <button type="submit" style={{ padding: '10px 16px', background: '#2c3e50', color: '#fff', border: 'none', borderRadius: 4 }}>Guardar contraseña</button>
          </form>
        </div>
      )}

      {status === 'success' && (
        <div>
          <p style={{ color: 'green' }}>Contraseña restablecida correctamente. Redirigiendo al login...</p>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
